//后台用户相关 api
import request from '@/api/request'



// 获取 修改页面数据
export function muserEditInitApi(id: string) {
    let url = '/api/manager/muser/edit/init';
    let data = {
        "id": id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 增加文章
export function muserAddApi(data: any) {
    let url = '/api/manager/muser/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 修改用户密码
export function muserPasswordChangeApi(data: any) {
    let url = '/api/manager/muser/edit/pwd';
    return request({
        url: url,
        method: 'post',
        data
    })
}


// 修改用户名
export function muserEditUsernameApi(data: any) {
    let url = '/api/manager/muser/edit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 更新用户密码
export function muserEditPasswordApi(data: any) {
    let url = '/api/manager/muser/edit/pwd';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 修改权限信息
export function muserEditRoleApi(muid:string,rid:string,isadmin:boolean,unitid:string,partyorgid:string) {
    let url = '/api/manager/muser/edit/role';
    let data = {
        "muid":muid,
        "rid":rid,
        "isadmin":isadmin,
        "unitid":unitid,
        "partyorgid":partyorgid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 获取单位级联信息
export function getCompanyInfoApi() {
    let url = '/api/manager/classunit/options/cascader';
    return request({
        url: url,
        method: 'post',
    })
}
// 获取党组织级联信息
export function getPartyInfoApi() {
    let url = '/api/manager/partyorg/options/cascader';
    return request({
        url: url,
        method: 'post',
    })
}

// 修改后台用户的绑定手机号
export function muserEditPhoneApi(data: any) {
    let url = '/api/manager/muser/updatep';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 绑定用户
export function muserBindUserApi(uid: string,muid:string) {
    let url = '/api/manager/muser/binduser';
    let data = {
        "uid" : uid,
        "muid":muid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 绑定用户
export function muserBindUserInitApi(muid:string) {
    let url = '/api/manager/muser/binduser/init';
    let data = {
        "muid":muid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function muserRoleInitApi(muid:string) {
    let url = '/api/manager/muser/edit/role/init';
    let data = {
        "muid":muid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}




